module.exports = "/img/_/_/_/assets/images/creeper/book/common//2.jpg?c268bf5626a76f947a710dc71d201411";